var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalStepsImg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.958496 44.0839C0.958496 40.5254 2.37204 37.113 4.88814 34.5968C7.40427 32.0808 10.8168 30.6672 14.3752 30.6672C16.0214 30.6523 17.6529 30.9785 19.1668 31.6256",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 44.0834H6.71387",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3828 34.5V38.3333",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3825 27.7917C18.6167 27.7917 22.0492 24.3591 22.0492 20.125C22.0492 15.8909 18.6167 12.4584 14.3825 12.4584C10.1483 12.4584 6.71582 15.8909 6.71582 20.125C6.71582 24.3591 10.1483 27.7917 14.3825 27.7917Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9745 19.0574C20.6206 19.7738 19.1093 20.1407 17.5776 20.1249C15.7777 20.1253 14.014 19.6186 12.4886 18.6631C10.9632 17.7075 9.73778 16.3416 8.95264 14.7219",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0493 1.91663V5.74996",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9661 3.83337H20.1328",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6533 19.1666V23",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5701 21.0834H40.7368",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3752 5.75H32.0085C30.7454 5.75 29.7219 6.11992 29.7219 7.66667C29.7219 10.1717 37.3886 12.8282 37.3886 15.3333C37.3886 16.6616 36.3651 17.25 35.102 17.25H29.7085",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5493 5.75V2.875",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5493 20.125V17.25",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5292 28.1444C23.6562 27.7626 23.9004 27.4304 24.2268 27.1952C24.5534 26.9599 24.9456 26.8332 25.3481 26.8334H42.3892C42.693 26.8334 42.9921 26.9054 43.2626 27.0436C43.533 27.182 43.7667 27.3827 43.9442 27.629C44.1218 27.8753 44.2384 28.1603 44.2844 28.4606C44.3302 28.7608 44.3041 29.0676 44.2081 29.3557L39.2918 44.0834H18.2085L23.5292 28.1444Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8722 37.375C30.8139 37.375 29.9556 36.5169 29.9556 35.4583C29.9556 34.3997 30.8139 33.5416 31.8722 33.5416",
    stroke: "#3B9FBF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8721 37.375C32.9306 37.375 33.7887 36.5169 33.7887 35.4583C33.7887 34.3997 32.9306 33.5416 31.8721 33.5416",
    stroke: "#3B9FBF",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalStepsImg6);
export default __webpack_public_path__ + "static/media/legalStepsImg6.4afc80cfcf799afc26c82f1021aae90c.svg";
export { ForwardRef as ReactComponent };